<wbo-search-page >
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="inventory">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="outletId">
                <wbo-outlet-multi-select-search-control></wbo-outlet-multi-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'status'">
                <wbo-entity-availability-single-select-search-control></wbo-entity-availability-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>

    </wbo-search-form>
    <wbo-search-grid>
        <wbo-column field="outlet"></wbo-column>
        <wbo-column field="inventory"></wbo-column>
        <wbo-column field="outletStockSize"></wbo-column>
        <wbo-numeric-column field="currentLevel" format="1.1-2"></wbo-numeric-column>
        <wbo-numeric-column field="onOrder" format="1.1-2"></wbo-numeric-column>
        <wbo-numeric-column field="onHold" format="1.1-2"></wbo-numeric-column>
        <wbo-numeric-column field="minLevel" format="1.1-2"></wbo-numeric-column>
        <wbo-numeric-column field="parLevel" format="1.1-2"></wbo-numeric-column>
        <wbo-column field="pendingTransfer"></wbo-column>
    </wbo-search-grid>
</wbo-search-page>
